<script setup>
import AudioPlayer from './AudioPlayer.vue'
import HorizontalNowPlaying from './nowplaying/HorizontalNowPlaying.vue'
import PromoBanner from './promobanner/PromoBanner.vue'
</script>

<template>
  <div class="flex-1 flex flex-col items-center md:justify-center py-6 space-y-4">
    <div class="hidden h-sm:block">
      <HorizontalNowPlaying />
    </div>
    <AudioPlayer />
    <PromoBanner class="hidden h-lg:block" />
  </div>
</template>
